
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__paintguide__",
      function () {
        return require("private-next-pages/__paintguide__/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__paintguide__"])
      });
    }
  